import MainImage from "../../assets/HeroImages/MainPot8.jpg";
import Footer from "../../components/Footer";
import Testimony from '../../components/Testimony'
import NavLite from '../../components/NavLite';


function About() {

  return (
    <main>
    <title>Meet Her Growth Co | Web Design & SEO Agency for Women Entrepreneurs</title>
<meta
name="description"
content="Discover the story behind Her Growth Co. We build digital platforms that empower women-led brands to thrive online through bold design and strategic SEO."
/>
<meta
name="keywords"
content="high-end website design texas, premium web design services, austin custom website development, conversion-focused web design, mobile responsive web design austin, website design for coaches, ux/ui website design austin, brand-first website design, premium branding website texas, website design for consultants, creative web design agency austin, bespoke web development texas, web design for personal brands austin, austin expert wordpress designer, strategic website design for leads, lead generation web design austin, custom web graphics austin, lightning-fast websites austin tx, mobile-first web design texas, expert website builder for women entrepreneurs, website design for experts texas, web designer for thought leaders, seo-ready website builds, visually engaging websites texas, ux design for female-led businesses, austin web design for women entrepreneurs, austin seo for female founders, website design for women-led businesses austin, custom websites for austin consultants, high-end website design austin, seo expert for women austin, premium branding austin women, austin digital authority launchpad, conversion-focused web design austin, web strategy for coaches austin, female entrepreneur seo services austin, austin cro expert services, all-in-one solution for experts, content marketing for women-led startups austin, seo for consultants in austin, website design agency austin tx, high-ticket client attraction austin, bespoke web design austin tx, online visibility for women founders, premium digital services austin, seo agency for women-owned business austin, women in business marketing austin, personal brand websites austin tx, social media + web strategy austin, website design for thought leaders austin
"
/>

    <section className="bg-[#F7F3F2]">
      <div
        className="relative h-auto bg-cover bg-top"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >

<NavLite/>


        <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
          <div className="flex items-center justify-center">
            <h1 className="text-black text-3xl max-w-40 font-semibold bg-[#CFF098] italic">About Us</h1>
          </div>
        </div>
      </div>

      <section className="bg-[#F7F3F2]">
        <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
          <div className="flex flex-col items-center text-center mb-12">
            <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl uppercase">
              Empowering women Entrepreneurs to Thrive Online
            </h2>
            <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
              At Her Growth Co, we're more than just a web design and SEO
              agency; we're your partners in online success. We specialize in
              empowering women-run small and medium businesses to elevate their
              digital presence, attract their ideal clients, and achieve
              sustainable growth.
            </p>
          </div>

          <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 md:gap-4">
            <div className="grid gap-6 p-8 md:p-10">
              <h3 className="text-xl font-semibold text-black">Our Mission</h3>
              <p className="text-black text-lg font-light">
                Our mission is to bridge the gap between your vision and your
                online reality. We believe that every women-led business
                deserves a powerful online platform that reflects their brand's
                authenticity and expertise.
              </p>
              <h3 className="text-xl font-semibold text-black mt-6">
                What Sets Us Apart
              </h3>
              <ul className="list-disc list-inside text-black text-lg font-light">
                <li>Focus on women-run Businesses</li>
                <li>Expertise in Web Design & SEO</li>
                <li>Local SEO Specialization</li>
                <li>Personalized Approach</li>
                <li>Proven Results</li>
              </ul>
            </div>

            <div className="grid gap-6 p-8 md:p-10">
              <h3 className="text-xl font-semibold text-black">Our Services</h3>
              <ul className="list-disc list-inside text-black text-lg font-light">
                <li>Custom Website Design</li>
                <li>Local SEO Optimization</li>
                <li>SEO-Optimized Service Pages</li>
                <li>Content Marketing Strategy</li>
                <li>Website Audits</li>
                <li>And more</li>
              </ul>
              <h3 className="text-xl font-semibold text-black mt-6">Our Values</h3>
              <ul className="list-disc list-inside text-black text-lg font-light">
                <li>Empowerment</li>
                <li>Collaboration</li>
                <li>Integrity</li>
                <li>Excellence</li>
                <li>Community</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col items-center text-center mt-12">
            <p className="max-w-lg text-base text-black md:text-lg font-light">
              We're passionate about helping you achieve your online goals.
              Contact us today to schedule a free website and SEO review and
              discover how we can help you take your business to the next level.
            </p>
            <a
              href="/free-review"
              className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black mt-8"
            >
              SCHEDULE YOUR FREE REVIEW →
            </a>
          </div>
        </div>
      </section>

      <Testimony/>
      <Footer />
      
    </section>
    </main>
  );
}

export default About;
